import React, { createContext, useContext } from "react";
import { useBoolean, UseBooleanReturn } from "../../custom-hooks/useBoolean";

interface ProdesegDropdownContextProps {
    children: React.ReactNode;
}

const voidFn = () => null;

const initialState: UseBooleanReturn = {
    value: false,
    setValue: voidFn,
    setTrue: voidFn,
    setFalse: voidFn,
    toggle: voidFn,
};

const ProdesegDropdownContext = createContext(initialState);

export const ProdesegDropdownContextProvider: React.FC<ProdesegDropdownContextProps> = ({ children }) => {
    const openState = useBoolean(false);

    return <ProdesegDropdownContext.Provider value={openState}>{children}</ProdesegDropdownContext.Provider>;
};

export const useProdesegDropdownContext = () => {
    const context = useContext(ProdesegDropdownContext);
    if (!context) throw new Error("useProdesegDropdownContext must be used within a ProdesegDropdownContextProvider");
    return context;
};
